import { Grid, useEventCallback } from '@mui/material';
import { Form, Formik, FormikHelpers } from 'formik';
import ModalInfoCertification from 'front-office/components/shared/info-certificate';
import ModalCertificate from 'front-office/components/claims/request-certificate-modal';
import ModalPrintSuccess from 'front-office/components/shared/request-print';
import { ClaimsCrumbs } from 'front-office/constants/claims-crumbs';
import { Fragment, useCallback, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import * as yup from 'yup';
import ClaimsForm from 'front-office/components/claims';
import { ClaimsFormVM } from 'front-office/view-models/claims/claims-form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CERTIFICATION_API_URL__, __PERSON_API_URL__ } from 'shell/constants/environment';
import { transformRequestClaimsData } from 'front-office/utils/transform-request-claims';
import { HttpResponse } from 'shell/models/http-response';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
// import { openPdf } from 'shell/utils/open-pdf';
import { ResponseCertificateGeneric } from 'shell/models/response-certificate-generic';
import { transformResponseRequestCertificateGeneric } from 'front-office/utils/transform-response-certificate-generic';
import PageButtons from 'front-office/components/shared/buttons-certificate';
import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { ModalViewerPDF } from 'shell/components/shared/pdf-modal';
import { AccordionAccountholderFormVM } from 'front-office/view-models/certificate/accountholder-form';
import { validationCertificationSchema } from 'front-office/constants/validation-shema/certification-schema';
import { AccordionApplicantFormVM } from 'front-office/view-models/certificate/applicant-form';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';
import PmiTitle from 'shell/components/shared/title';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';

const validationSchema = yup
  .object()
  .shape({
    ...validationCertificationSchema,
    claims: yup
      .object()
      .nullable()
      .shape({
        key: yup.object().shape({
          codiceDocumento: yup.string(),
        }),
      }),
    dateForm: yup.date().nullable().typeError('Data non valida'),
    accountholder: yup
      .object()
      .shape({})
      .test('accountHolder', 'Campo obbligatorio', (values) => {
        const valuesCasted = values as unknown as AccordionAccountholderFormVM;

        // same as applicant
        if (valuesCasted?.sameApplicant) {
          return true;
        }

        // fiscal code required
        if (!valuesCasted?.account?.applicant?.fiscalCode) {
          return new yup.ValidationError(
            'Campo obbligatorio',
            undefined,
            'accountholder.account.applicant.fiscalCode'
          );
        }

        if (!valuesCasted?.sameApplicant) {
          if (
            valuesCasted?.account?.generality?.isForeignDocument ===
            DocumentRadioCertificate.IdentityCard
          ) {
            if (!valuesCasted?.account?.generality?.municipalityDocument) {
              return new yup.ValidationError(
                'Campo obbligatorio',
                undefined,
                'accountholder.account.generality.municipalityDocument'
              );
            }
          }
          if (!valuesCasted?.account?.generality?.numberDocument) {
            return new yup.ValidationError(
              'Campo obbligatorio',
              undefined,
              'accountholder.account.generality.numberDocument'
            );
          }

          if (!valuesCasted?.account?.generality?.dateReleaseDocument) {
            return new yup.ValidationError(
              'Campo obbligatorio',
              undefined,
              'accountholder.account.generality.dateReleaseDocument'
            );
          }
          if (
            valuesCasted?.account?.generality?.isForeignDocument === DocumentRadioCertificate.Other
          ) {
            if (!valuesCasted?.account?.generality?.consulateCode) {
              return new yup.ValidationError(
                'Campo obbligatorio',
                undefined,
                'accountholder.account.generality.consulateCode'
              );
            }
          }
        }
        // search required
        if (!valuesCasted?.searchAccountholder) {
          return new yup.ValidationError(
            'Effettuare ricerca',
            undefined,
            'accountholder.searchAccountholder'
          );
        }

        return true;
      }),
  })
  .test('', '', (values) => {
    const castedValues = values as unknown as ClaimsFormVM;

    if (!castedValues.dateForm && castedValues.claims?.key.codiceDocumento === '4') {
      return new yup.ValidationError('Il campo è obbligatorio', undefined, 'dateForm');
    }
    return true;
  })
  .test('', '', (values) => {
    const valuesCasted = values as unknown as ClaimsFormVM;

    const accountHolder = values?.accountholder as AccordionAccountholderFormVM;
    const applicant = values?.applicant as AccordionApplicantFormVM;

    const isApplicantItalian = values?.applicant?.isItalian;
    const isAccountHolderItalian = (values?.accountholder as AccordionAccountholderFormVM)?.account
      ?.applicant?.isItalian;

    // const isApplicantBritish = valuesCasted?.generality?.dati3002?.cittadinanza?.find(
    //   (el) => el.codiceStato === '219'
    // );

    // const isAccountholderBritish =
    //   valuesCasted?.accountholder?.account?.generality?.dati3002?.cittadinanza?.find(
    //     (el) => el.codiceStato === '219'
    //   );

    // const isApplicantEuropean = valuesCasted?.generality?.dati3002?.cittadinanza?.find(
    //   (el) => el.flagUnioneEuropea === '1' || el.flagUnioneEuropea === '2'
    // );

    // const isAccountholderEuropean =
    //   valuesCasted?.accountholder?.account?.generality?.dati3002?.cittadinanza?.find(
    //     (el) => el.flagUnioneEuropea === '1' || el.flagUnioneEuropea === '2'
    //   );

    // same as applicant
    if (valuesCasted?.accountholder?.sameApplicant) {
      if (isApplicantItalian) {
        return new yup.ValidationError('Richiedente italiano', undefined, 'applicant.fiscalCode');
      }
      // if (!isApplicantBritish && !isApplicantEuropean) {
      //   return new yup.ValidationError(
      //     'Richiedente né europeo né britannico',
      //     undefined,
      //     'applicant.fiscalCode'
      //   );
      // }
      if (!valuesCasted?.certifiableApplicant) {
        return new yup.ValidationError(
          'Soggetto non certificabile',
          undefined,
          'certifiableApplicant'
        );
      }
    } else {
      if (accountHolder?.account?.applicant?.fiscalCode === applicant?.fiscalCode) {
        return new yup.ValidationError(
          `Richiedente è uguale all'intestatario`,
          undefined,
          'applicant.fiscalCode'
        );
      }
      if (isAccountHolderItalian) {
        return new yup.ValidationError(
          'Intestatario italiano',
          undefined,
          'accountholder.account.applicant.fiscalCode'
        );
      }
      // if (!isAccountholderBritish && !isAccountholderEuropean) {
      //   return new yup.ValidationError(
      //     'Intestatario né europeo né britannico',
      //     undefined,
      //     'accountholder.account.applicant.fiscalCode'
      //   );
      // }
      if (!valuesCasted?.accountholder?.certifiableAccountholder) {
        return new yup.ValidationError(
          'Soggetto non certificabile',
          undefined,
          'certifiableAccountholder'
        );
      }
    }

    return true;
  });

const ClaimsPage = (): React.ReactElement => {
  const [certificatePdf, getPdfCertificate] = useHttpFetch<
    HttpResponse<ResponseCertificateGeneric>,
    HttpResponse<ResponseCertificateGeneric>
  >(`${__CERTIFICATION_API_URL__}/richiesta-certificato/generico`, {
    onBootstrap: false,
    options: {
      method: 'POST',
    },
    transformer: transformResponseRequestCertificateGeneric,
  });

  const checkClaims = useHttpClient(`${__PERSON_API_URL__}/persona/autentiche/check`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  // Casted response certificate
  const dataCertificate = certificatePdf.data as HttpResponse<ResponseCertificateGeneric>;

  // ModalCertificate
  const [open, setOpen] = useState<boolean>(false);

  // ModalPrintSuccess
  const [modalPrintSuccess, setModalPrintSuccess] = useState<{ open: boolean; total?: number }>({
    open: false,
  });

  // InfoCertification
  const [infoCertification, setInfoCertification] = useState<{ open: boolean; total?: number }>({
    open: false,
  });

  const { userProfile } = useUserProfile();
  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa;

  const [pdfModal, setPdfModal] = useState({ data: '', open: false, name: '' });

  // Handle the submit
  const handleSubmit = useCallback(
    (values: ClaimsFormVM) => {
      if (values.accountholder?.sameApplicant) {
        (
          checkClaims({
            data: {
              ...(values.generality?.dati3002 || {}),
            },
          }) as ResponsePromise<void>
        ).then(() => {
          setOpen(true);
        });
      }
      setOpen(true);
    },
    [setOpen]
  );

  const onRequestCertificate = useEventCallback(
    (values: ClaimsFormVM, formContext: FormikHelpers<ClaimsFormVM>) => {
      const data = transformRequestClaimsData(values);

      (
        getPdfCertificate({ data }) as ResponsePromise<
          HttpResponse<ResponseCertificateGeneric>,
          HttpResponse<ResponseCertificateGeneric>
        >
      ).then((response) => {
        const responseCasted = response as HttpResponse<ResponseCertificateGeneric>;
        const pdfCertificate = responseCasted?.payload?.contenutoPdfCertificato;

        const { modality } = values;

        const {
          amountRightsSecretariat = 0.0,
          amountRightsCivilState = 0.0,
          amountFixedRights = 0.0,
          amountExpenses = 0.0,
          amountTaxStamp = 0.0,
        } = modality || {};

        const rights =
          amountExpenses +
          amountFixedRights +
          amountRightsCivilState +
          amountRightsSecretariat +
          amountTaxStamp;

        // close ModalCertificate
        setOpen(false);

        formContext.setValues({
          ...values,
          claims: null,
          citizenUE: false,
          modality: null,
          typePayment: '',
          dateForm: null,
        });

        if (pdfCertificate) {
          // openPdf(pdfCertificate);
          setPdfModal({ data: pdfCertificate, name: 'Attestazione', open: true });
        }

        const parsedTotal = values?.certificateInternOnly
          ? Number.parseFloat('0,00')
          : Number.parseFloat(rights?.toString() || '0,00');

        // const total = (values?.payment || 0) + parsedTotal;

        // setFieldValue('payment', total);

        //open ModalPrintSuccess
        setModalPrintSuccess({ open: false, total: parsedTotal });
      });
    }
  );

  const onYes = useEventCallback(
    (
      values: CommonRequestCertificateInterface,
      setFieldValue: (
        key: keyof CommonRequestCertificateInterface,
        value: CommonRequestCertificateInterface[keyof CommonRequestCertificateInterface]
      ) => void
    ) => {
      const total = (values?.payment || 0) + (modalPrintSuccess?.total || 0);

      setFieldValue('payment', total);

      // close ModalPrintSuccess
      setModalPrintSuccess({ open: false, total: undefined });

      //open InfoCertification
      setInfoCertification({ open: true, total: modalPrintSuccess.total });
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={ClaimsCrumbs} base="sportello" />
      <div>
        <PmiTitle title="Attestazione" />
      </div>
      <div className="pmi-mt-4">
        <div className="pmi-mt-2">
          <Formik
            validationSchema={validationSchema}
            initialValues={
              {
                accountholder: { sameApplicant: true },
                payment: 0,
                certificateInternOnly: cashManagement !== 'S' ? true : false,
                intendedUse: '0',
                generality: {
                  isForeignDocument: DocumentRadioCertificate.IdentityCard,
                },
              } as ClaimsFormVM
            }
            onSubmit={(values, formContext) => onRequestCertificate(values, formContext)}
            validateOnChange
            validateOnBlur
            // validateOnMount
          >
            <Form>
              <Grid container spacing={1}>
                <Grid item xs={12} md={3}>
                  <PageButtons
                    handleRequestCertificate={handleSubmit}
                    label="Attestazione"
                    isClaims
                    hasCleanAccountholder
                  />
                </Grid>
                <Grid item xs={12} md={9}>
                  <div className="pmi-px-md-4">
                    <ClaimsForm />
                  </div>
                </Grid>
              </Grid>
              <ModalCertificate open={open} onClose={setOpen} />
              <ModalPrintSuccess
                open={modalPrintSuccess.open}
                onClose={() => setModalPrintSuccess({ open: false })}
                onYes={onYes}
              />
              <ModalInfoCertification
                open={infoCertification.open}
                onClose={() => setInfoCertification({ open: false })}
                title={dataCertificate?.payload?.numeroIdentificativoDocumento}
                amountCertifate={infoCertification.total?.toFixed(2)}
              />
              <ModalViewerPDF
                open={pdfModal.open}
                data={pdfModal.data}
                name={pdfModal.name}
                title="Certificazione"
                onClose={() => {
                  setPdfModal({ data: '', open: false, name: '' });
                  setModalPrintSuccess((oldState) => ({ ...oldState, open: true }));
                }}
              />
            </Form>
          </Formik>
        </div>
      </div>
    </Fragment>
  );
};

ClaimsPage.displayName = 'Claims page';

export default ClaimsPage;
